import { render, staticRenderFns } from "./community-standards-overlay.vue?vue&type=template&id=569e5c29&scoped=true&"
import script from "./community-standards-overlay.vue?vue&type=script&lang=js&"
export * from "./community-standards-overlay.vue?vue&type=script&lang=js&"
import style0 from "./community-standards-overlay.vue?vue&type=style&index=0&id=569e5c29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569e5c29",
  null
  
)

export default component.exports